{% block hueb_seo_robots %}
    <div>
        <mt-select
            :placeholder=false
            v-model="selected"
            :options="options"
            @update:model-value="onChange">
        </mt-select>
    </div>
{% endblock %}
